// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.overlay {\n  display: none;\n  position: fixed;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(0, 0, 0, 0.7);\n  z-index: 2147483646;\n  top: 0;\n  opacity: 0;\n  transition: all 0.5s ease-in-out;\n}\n.overlay.active {\n  display: block;\n  opacity: 1;\n}\n", ""]);
// Exports
module.exports = exports;
